import { TextInputValidator } from "../utils/TextInputValidator";
import { EmailInputValidator } from "../utils/EmailInputValidator";
import { PasswordInputValidator } from "../utils/PasswordInputValidator";

export class AuthFormValidator {
  static validateSignUpForm(signUpForm) {
    let username = signUpForm.username;
    let email = signUpForm.email;
    let password = signUpForm.password;
    let repeatedPassword = signUpForm.repeatedPassword;
    let errors = {
      ...this.validateUsername(username),
      ...this.validateEmail(email),
      ...this.validatePasswordSignUp(password),
      ...this.validateRepeatedPassword(password, repeatedPassword),
    };

    return errors;
  }

  static validateSignInForm(signUpForm) {
    let username = signUpForm.username;
    let password = signUpForm.password;
    let errors = {
      ...this.validateUsername(username),
      ...this.validatePasswordSignIn(password),
    };

    return errors;
  }

  static validateUsername(username) {
    if (TextInputValidator.isTextInputBlank(username)) {
      return { username: "Username is required" };
    }

    return {};
  }

  static validateEmail(email) {
    if (TextInputValidator.isTextInputBlank(email)) {
      return { email: "Email is required" };
    } else if (!EmailInputValidator.isTextInputValidEmail(email)) {
      return { email: "Not a valid email, please try again." };
    }

    return {};
  }

  static validatePasswordSignIn(password) {
    if (TextInputValidator.isTextInputBlank(password)) {
      return { password: "Enter Password" };
    }

    return {};
  }

  static validatePasswordSignUp(password) {
    if (TextInputValidator.isTextInputBlank(password)) {
      return { password: "Enter Password" };
    } else if (!PasswordInputValidator.isPasswordLongEnough(password)) {
      return { password: "Password must be at least 6 characters long" };
    }

    return {};
  }

  static validateRepeatedPassword(password, repeatedPassword) {
    if (TextInputValidator.isTextInputBlank(repeatedPassword)) {
      return { repeatedPassword: "Enter Password" };
    } else if (
      !TextInputValidator.isTextInputBlank(password) &&
      !PasswordInputValidator.passwordsMatch(password, repeatedPassword)
    ) {
      return { repeatedPassword: "Passwords do not match" };
    }

    return {};
  }
}
